module.exports = __webpack_public_path__ + "static/media/main_page.f83bd223.png";